import React from 'react';

import Grid from '@mui/material/Grid2';

import ResourcesGrid from '../../components/ResourcesGrid';

function AllResources(props) {
  const { nodes, path, appId } = props;

  return (
    <Grid
      size={{ xs: 12 }}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        maxWidth: '100vw',
      }}>
      <ResourcesGrid appId={appId} nodes={nodes} path={path} />
    </Grid>
  );
}

export default AllResources;
